/** Driving and road constants. Shared so the server can bound scores with the same numbers. */
export const LANES = 3;
export const LANE_WIDTH = 3.4;
/** Index of the kerb lane (rightmost), where passengers board. */
export const KERB_LANE = 2;

export const SPEED = {
  /** Cruise speed at the start of a run, m/s (~43 km/h). */
  start: 12,
  /** Cruise speed cap, m/s (180 km/h; about 252 km/h with gas). */
  max: 40,
  /** Cruise speed gained per second of driving. */
  rampPerSec: 0.16,
  /** Holding gas multiplies cruise speed by this. */
  gasMultiplier: 1.4,
  /** Above this fraction of cruise speed the run counts as "fast". */
  fastThreshold: 1.18,
  accel: 7,
  brakeDecel: 22,
  coastDecel: 5,
} as const;

/**
 * Touch screens pick up speed faster: quicker acceleration off the line (0 → 43 km/h in about a second)
 * and a cruise speed that climbs to the top in about a minute instead of two. Top speed is the same.
 */
export const TOUCH_SPEED = {
  accel: 12,
  rampPerSec: 0.3,
} as const;

export const HOP = {
  velocity: 8.5,
  gravity: 24,
} as const;

/** Siren Boost speed multiplier, and Speed-Ramp Launch hop multiplier. */
export const SIREN_SPEED_BOOST = 1.6;
export const LAUNCH_HOP_BOOST = 1.5;

/** Highest possible speed (gas + Siren Boost), used by score plausibility checks. */
export const MAX_POSSIBLE_SPEED = SPEED.max * SPEED.gasMultiplier * SIREN_SPEED_BOOST;
